import {
  makeGetRequest,
  makePostRequest,
  makeDeleteRequest,
  makePutRequest,
  makeLeadsGetRequest,
  makeLeadsPostRequest,
  makeLeadsPutRequest,
  makeLeadsDeleteRequest
} from 'utils/api'

export const getChecklists = (url, module) =>
  module === 'leads' ? makeLeadsGetRequest(url) : makeGetRequest(url)

export const postChecklist = (url, payload, module) =>
  module === 'leads' ? makeLeadsPostRequest(url, payload) : makePostRequest(url, payload)

export const putChecklist = (url, payload, module) =>
  module === 'leads' ? makeLeadsPutRequest(url, payload) : makePutRequest(url, payload)

export const removeChecklist = (url, module) =>
  module === 'leads' ? makeLeadsDeleteRequest(url) : makeDeleteRequest(url)
